import Script from 'next/script';

import { BAZAAR_VOICE_SCRIPT_SRC } from '../../constants';

export function BazaarVoiceScript() {
    return <Script id="bazaar-voice" data-testid="bv-script" async src={BAZAAR_VOICE_SCRIPT_SRC} />;
}
